export function formatDate(inputDate) {
  // Parse the input date string
  const [datePart, timePart] = inputDate.split(" ");
  const [day, month, year] = datePart.split("-").map(Number);
  const [hours, minutes] = timePart.split(":").map(Number);

  // Create a Date object
  const date = new Date(year, month - 1, day, hours, minutes);

  // Format options
  const options = {
    month: "short", // Short month name (e.g., "Dec")
    day: "numeric", // Day of the month
    hour: "numeric", // Hour in 12-hour format
    minute: "numeric", // Minutes
    hour12: true, // Use 12-hour time with AM/PM
  };

  // Format the date
  const formattedDate = date.toLocaleString("en-US", options);

  return formattedDate;
}

export function formatDateYear(inputDate) {
  // Parse the input date string
  const [datePart, timePart] = inputDate.split(" ");
  const [day, month, year] = datePart.split("-").map(Number);
  const [hours, minutes] = timePart.split(":").map(Number);

  // Create a Date object
  const date = new Date(year, month - 1, day, hours, minutes);

  // Format options
  const options = {
    year: "numeric", // Year (e.g., "2024")
    month: "short", // Short month name (e.g., "Dec")
    day: "numeric", // Day of the month
    hour: "numeric", // Hour in 12-hour format
    minute: "numeric", // Minutes
    hour12: true, // Use 12-hour time with AM/PM
  };

  // Format the date
  const formattedDate = date.toLocaleString("en-US", options);

  return formattedDate;
}

export function addHour(dateStr, hoursToAdd = 2) {

  const [datePart, timePart] = dateStr.split(" ");
    const [day, month, year] = datePart.split("-").map(Number);
    const [hour, minute] = timePart.split(":").map(Number);

    // Create a JavaScript Date object
    const date = new Date(year, month - 1, day, hour, minute);

    // Add the hours
    date.setHours(date.getHours() + hoursToAdd);

    // Format to "Jul 18, 7:30 PM"
    const options = {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
    };

    return date.toLocaleString("en-US", options);
}

export function getDay(inputDate) {
  // Parse the input date string
  const [datePart, timePart] = inputDate.split(" ");
  const [day, month, year] = datePart.split("-").map(Number);
  const [hours, minutes] = timePart.split(":").map(Number);

  // Create a Date object
  let date = new Date(year, month - 1, day, hours, minutes);

  // Format options
  let options = {
    month: "short", // Short month name (e.g., "Dec")
    day: "numeric", // Day of the month
    hour: "numeric", // Hour in 12-hour format
    minute: "numeric", // Minutes
    hour12: true, // Use 12-hour time with AM/PM
  };

  // Format the date
  date = new Date(date);
  options = { weekday: 'long' };

  return date.toLocaleDateString('en-US', options);
}

export function isPastDate(input) {
  const now = new Date();

  // Get current year to add to input string
  const currentYear = now.getFullYear();

  // Parse the input with year appended to ensure valid Date
  const fullDateStr = `${input}, ${currentYear}`;
  const inputDate = new Date(fullDateStr);

  // Compare
  return inputDate < now;
}